class modalSureSelConCtrl {
    constructor($scope, $uibModalInstance, items1, httpRequest, logger, modalSelConDetailService) {
        $scope.reqArrLen = items1.reqArrLen
        $scope.activeTab = items1.activeTab
        $scope.totalAmt = (Math.round(items1.totalAmt * 100) / 100).toFixed(2)
        $scope.totalTaxamt = (Math.round(items1.totalTaxamt * 100) / 100).toFixed(2)
        const inputDeviceType = (localStorage.inputDeviceType && JSON.parse(localStorage.getItem('inputDeviceType'))) || {}
        // items1.selectionType
        $scope.cancel = () => {
            // $uibModalInstance.dismiss();
            $uibModalInstance.close()
        }
        $scope.ok = () => {
            const opening = window.layer.msg('正在处理，请您耐心等待···', {
                time: 0,
                skin: 'layer-loading-self',
                icon: 16,
                shade: 0.5,
            })
            httpRequest.get_getIsCheckOrNotOperate({ periodCode: items1.periodCode, checkType: 1 }).then(res => {
                if (res.data.value) {
                    httpRequest.post_qryIvatConfig().then((res) => {
                        // console.log(reqStr);
                        // 单机版
                        if (res.data.value.diskType == 1) {
                            const singleResObj = {
                                TAXNO: res.data.value.creditCode,
                                PASS: res.data.value.diskPassword,
                                ptPassword: res.data.value.platformPassword,
                                DATA: items1.reqStr,
                                VERSION: '',
                                TaxType: 1,
                                deviceType: inputDeviceType.deviceType
                            }
                            const singleResJson = JSON.stringify(singleResObj)
                            // console.log(modalSelConDetailService);
                            const b = modalSelConDetailService.Base64()
                            const singleReqBase64 = b.encode(singleResJson)
                            $.ajax({
                                url: res.data.value.serverAddress,
                                type: 'POST',
                                data: {
                                    SID: 440302,
                                    SIDParam: singleReqBase64,
                                },
                                dataType: 'jsonp',
                                timeout: 60000,
                                success(res) {
                                    res = JSON.stringify(res)
                                    const CheckParamDTO = {
                                        checkFlag: $scope.activeTab,
                                        checked: items1.checked,
                                        u72Response: res,
                                        periodCode: items1.periodCode,
                                        checkType: items1.checkType,
                                        checkInvoices: items1.checkInvoices,
                                        isCustomsPayment: '0',
                                    }
                                    httpRequest.post_ivatDrawbackCheck_updateCheckStatusLocal(CheckParamDTO).then((res) => {
                                        window.layer.close(opening)
                                        $scope.pageChanged()
                                        if (!res.data.success) {
                                            logger.logError(res.data.msgCode)
                                        }
                                        logger.logSuccess('提交成功')
                                    }, () => {
                                        window.layer.close(opening)
                                        $scope.pageChanged()
                                    })
                                },
                                error() {
                                    window.layer.close(opening)
                                    $scope.pageChanged()
                                    logger.logError('u72请求错误')
                                },
                            })
                        } else {
                            const CheckParamDTO = {
                                checkFlag: $scope.activeTab,
                                checked: items1.checked,
                                periodCode: items1.periodCode,
                                checkType: items1.checkType,
                                checkInvoices: items1.checkInvoices,
                                deviceType: inputDeviceType.deviceType,
                                isCustomsPayment: '0',
                            }
                            httpRequest.post_ivatDrawbackCheck_updateCheckStatusServer(CheckParamDTO).then((res) => {
                                window.layer.close(opening)
                                $scope.pageChanged()
                                if (!res.data.success) {
                                    logger.logError(res.data.msgCode)
                                }
                                logger.logSuccess('提交成功')
                            }, () => {
                                window.layer.close(opening)
                                $scope.pageChanged()
                            })
                        }
                    }, () => {
                        $scope.pageChanged()
                    })
                } else {
                    logger.logError('已申请统计或确认签名，不能发票勾选，请先撤销统计或撤销签名')
                }
            })

            $uibModalInstance.close()
        }
    }
}

modalSureSelConCtrl.$inject = ['$scope', '$uibModalInstance', 'items1', 'httpRequest', 'logger', 'modalSelConDetailService']
export default modalSureSelConCtrl


// WEBPACK FOOTER //
// ./src/components/drawBack/modalSureSelConCtrl.js